import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Row } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { getColor } from 'helpers/utils';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';

import {
  GridComponent,
  TooltipComponent,
  TitleComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import BasicECharts from 'components/common/BasicEChart';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer
]);

const getOptions = (data, radius, total) => ({
  color: data.map(item => getColor(item.color)),
  tooltip: {
    padding: [7, 10],
    transitionDuration: 0,
    backgroundColor: getColor('100'),
    borderColor: getColor('300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    formatter: params => `<strong>${params.data.name}:</strong> ${params.value}`
  },
  series: [
    {
      name: total,
      type: 'pie',
      radius,
      avoidLabelOverlap: false,
      emphasis: {
        scale: false
      },
      itemStyle: {
        borderWidth: 2,
        borderColor: getColor('card-bg')
      },
      label: {
        show: true,
        position: 'center',
        formatter: '{a}',
        fontSize: 23,
        color: getColor('dark')
      },
      data
    }
  ]
});
const MarketShareItem = ({ item, index, total }) => {
  const { name, color, value } = item;

  const percentage = total === 0 ? 0 : ((value * 100) / total).toFixed(0);
  return (
    <Flex
      alignItems="center"
      className={`fw-semi-bold fs--2 ${index == 0 && 'mt-3'}`}
    >
      <div className="mb-1" style={{ display: 'flex', alignItems: 'center' }}>
        <FontAwesomeIcon
          icon="circle"
          className={`me-2 text-${color || 'text-info'}`}
        />
        <span>{name}</span>
        <span style={{ marginLeft: '5px' }}>{percentage}%</span>
      </div>
    </Flex>
  );
};

const MarketShare = ({ data, now, radius, cardClasses, title }) => {
  const total = data.reduce((acc, val) => val.value + acc, 0);

  return (
    <Card className={`bg-white ${cardClasses} mb-3 w-100`}>
      <Card.Body>
        <Row className="justify-content-start g-0">
          <Col xs={6}>
            <h6 className="mt-1">{title}</h6>

            {data.map((item, index) => (
              <MarketShareItem
                item={item}
                index={index}
                key={index}
                total={total}
              />
            ))}
          </Col>
          <Col
            xs="auto"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '1rem'
            }}
          >
            <div className="ps-0">
              <BasicECharts
                echarts={echarts}
                options={getOptions(data, radius, now)}
                style={{ width: '6.625rem', height: '6.625rem' }}
              />
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

MarketShareItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  }),
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};

MarketShare.propTypes = {
  data: PropTypes.array.isRequired,
  radius: PropTypes.array.isRequired,
  cardClasses: PropTypes.string,
  title: PropTypes.string,
  now: PropTypes.number.isRequired
};

export default MarketShare;
